import React from "react";
import { Card, CardBody, CardTitle, Progress } from "reactstrap";
import IntlMessages from "../../../../../helpers/IntlMessages";
import { localeOptions } from "../../../../../constants/defaultValues";

const LanguageDistributionStats = ({ cardClass = "h-100", data }) => {
    console.log(6, data);
    return (
        <Card className={cardClass}>
            <div style={{ padding: '15px' }}>
                <div className="float-left float-none-xs">
                    <div className="d-inline-block">
                        <h5 className="d-inline">Language Distribution</h5>
                        <span className="text-muted text-small d-block">
                            Language Distribution
                        </span>
                    </div>
                </div>
            </div>
            <CardBody>
                {data !== null && data !== undefined && data.length > 0 && data.map((s, index) => {
                    return (
                        <div key={index} className="mb-4">
                            <p className="mb-2">
                                {localeOptions.filter(l => l.id === (s.languageCode === "zh-TW" ? "hk" : s.languageCode)).map(k => k.name)}
                                <span className="float-right text-muted">
                                    {s.percentage}%
                                </span>
                            </p>
                            <Progress value={s.percentage} max={100} style={{ height: "10px" }} />
                        </div>
                    );
                })}
            </CardBody>
        </Card>
    );
};
export default LanguageDistributionStats;